import template from "./dialog-config.html";
import css from "./dialog-config.css";
import Dialog from "dialog";
import sleep from "sleep";


class ConfigVisifermPHDialog extends Dialog {
  static get template() {
    return template;
  }
  static get css() {
    return css;
  }
  static constructor() {
    customElements.define("fulljs-dialog-config-visifermph", ConfigVisifermPHDialog);
  }
  constructor() {
    super();

    document.addEventListener("onupdatedevices", this.onupdatedevices_handler.bind(this));

    this.onupdatedevices_handler({detail: application.devices});

    this.show();
  }
  async buttonClearCalibration_click() {
    try {
      this.buttonClearCalibration.style.pointerEvents = "none";
      this.buttonClearCalibration.icon.iconname = "view-refresh";
      await server.rcall("RM_visifermph_clearCalibration");
      this.buttonClearCalibration.icon.iconname = "dialog-ok-apply";
    } catch(e) {
      error(e);
      this.buttonClearCalibration.icon.iconname = "process-stop";
    } finally {
      await sleep(3000);
      this.buttonClearCalibration.icon.iconname = "dialog-ok";
      this.buttonClearCalibration.style.pointerEvents = "";
    }
  }
  async buttonCalibrateTo7_click() {
    try {
      this.buttonCalibrateTo7.style.pointerEvents = "none";
      this.buttonCalibrateTo7.icon.iconname = "view-refresh";
      await server.rcall("RM_visifermph_calibrateTo7");
      this.buttonCalibrateTo7.icon.iconname = "dialog-ok-apply";
    } catch(e) {
      error(e);
      this.buttonCalibrateTo7.icon.iconname = "process-stop";
    } finally {
      await sleep(3000);
      this.buttonCalibrateTo7.icon.iconname = "dialog-ok";
      this.buttonCalibrateTo7.style.pointerEvents = "";
    }
  }
  async buttonCalibrateTo4_click() {
    try {
      this.buttonCalibrateTo4.style.pointerEvents = "none";
      this.buttonCalibrateTo4.icon.iconname = "view-refresh";
      await server.rcall("RM_visifermph_calibrateTo4");
      this.buttonCalibrateTo4.icon.iconname = "dialog-ok-apply";        
    } catch(e) {
      error(e);
      this.buttonCalibrateTo4.icon.iconname = "process-stop";
    } finally {
      await sleep(3000);
      this.buttonCalibrateTo4.icon.iconname = "dialog-ok";
      this.buttonCalibrateTo4.style.pointerEvents = "";
    }
  }
  onupdatedevices_handler(event) {
    var devices = event.detail;

    this.textboxDeviceID.value = devices.visifermph.id;
    this.textboxDeviceStatus.value = devices.visifermph.status;
    this.textboxValue.value = devices.visifermph.value;
    this.textboxCalibrationStatus.value = devices.visifermph.calibrationStatus;
    this.textboxInternalTemperature.value = devices.visifermph.internalTemperature;      
  }
  buttonClose_click(event) {
    this.close();
  }
  close() {
    super.close();
  }
}

ConfigVisifermPHDialog.constructor();

export default ConfigVisifermPHDialog;